import { Injectable } from '@angular/core';
import { Resolve, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileDataService implements Resolve<any> {
  constructor(private API: ApiService, private router: Router) {}

  resolve() {
    return this.API.AuthGET('public/shoppers').pipe(
      catchError(() => {
        this.router.navigate(['/']);
        return of(null);
      })
    );
  }
}
